import { Suspense } from 'react';
import { Outlet, Route } from 'react-router';
import { BillingPage, PendingUpgradePage, UpgradeSuccessModal } from '#route-bundles/authenticated.tsx';
import { NotFound } from '#screens/404/NotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { IsMFAUser } from '#screens/settings/IsMFAUser.tsx';
import { fromArray, page, Titled } from '#util/title.ts';

export const billingRootRoute = (
  <Route
    HydrateFallback={() => null}
    element={
      <Titled title={(title) => fromArray(['Billing', title])}>
        <Suspense fallback={<LoadingSpinner />}>
          <Outlet />
        </Suspense>
      </Titled>
    }
  >
    <Route
      element={
        <>
          <BillingPage />
          <Outlet />
        </>
      }
    >
      <Route
        index={true}
        element={null}
        /**  We just want to mark this as the index route, render the above layout routes. */
      />
      <Route
        path="upgrade-success"
        element={
          <Titled title={() => page('Upgrade succeeded')}>
            <UpgradeSuccessModal />
          </Titled>
        }
      />
    </Route>
    <Route
      element={
        <IsMFAUser redirectTo={'/settings/billing'}>
          <Outlet />
        </IsMFAUser>
      }
    >
      <Route
        path="checkout"
        // Lazy load the checkout page to avoid Stripe unless necessary.
        lazy={() =>
          import('./checkout/CheckoutPage.tsx').then(({ CheckoutPageWithStripe }) => ({
            Component: CheckoutPageWithStripe,
          }))
        }
      />
      <Route path="upgrade-pending" element={<PendingUpgradePage />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Route>
);
